var map = {
	"./i18n/options.i18n.fr-fr.js": "Psxa",
	"./i18n/ors-dictionary.i18n.fr-fr.js": "mEbU",
	"./i18n/ors-map-filters.i18n.fr-fr.js": "vPsk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mJ9A";